import { render } from "./AtualizadoSucesso.vue?vue&type=template&id=3b2c1c69&scoped=true"
import script from "./AtualizadoSucesso.vue?vue&type=script&lang=js"
export * from "./AtualizadoSucesso.vue?vue&type=script&lang=js"

import "./AtualizadoSucesso.vue?vue&type=style&index=0&id=3b2c1c69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2c1c69"]])

export default __exports__